var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g2, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g3, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g4, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatsectionicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 397,
    viewBox: "0 0 428 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.625 96.6307C110.974 80.7077 125.438 56.4839 142.224 47.6005C156.249 40.1772 172.39 35.7458 188.059 38.2555C203.729 40.7652 218.64 62.1654 223.688 77.2097",
    stroke: "#F1CB6B",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10,
    strokeDasharray: "3.72 1.86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7225 138.96C20.1412 151.902 3.93952 177.384 2.22396 204.228C0.0476978 238.284 21.214 271.772 51.4773 287.542C81.7406 303.312 119.346 302.199 150.333 287.904C179.646 274.382 204.387 247.609 208.33 215.57",
    stroke: "#F1CB6B",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10,
    strokeDasharray: "3.72 1.86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.051 127.294C275.473 90.2999 326.751 82.023 374.082 95.4187C445.826 115.723 452.463 277.67 340.858 261.67C295.835 255.216 254.377 228.577 227.799 191.667",
    stroke: "#F1CB6B",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10,
    strokeDasharray: "3.72 1.86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M125.786 99.9727H84.6747L78.4292 88.5062C77.6025 86.9876 76.0114 86.043 74.2828 86.043H21.5064C18.8992 86.043 16.7852 88.157 16.7852 90.7642V99.9718V259.567C16.7852 263.196 19.7268 266.138 23.3557 266.138H125.786C129.415 266.138 132.356 263.196 132.356 259.567V106.543C132.356 102.914 129.415 99.9727 125.786 99.9727Z",
    fill: "#EFE8E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3751 254.034C29.9282 254.034 27.124 251.229 27.124 247.783V88.7988H135.514C138.961 88.7988 141.766 91.603 141.766 95.0499V247.783C141.766 251.23 138.961 254.033 135.514 254.033H33.3751V254.034Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.514 89.2632C138.705 89.2632 141.301 91.8593 141.301 95.0499V247.783C141.301 250.974 138.705 253.57 135.514 253.57H33.3737C30.1822 253.57 27.587 250.973 27.587 247.783V89.2632H135.514ZM135.514 88.3344H26.6582V247.783C26.6582 251.492 29.6648 254.498 33.3737 254.498H135.514C139.223 254.498 142.229 251.492 142.229 247.783V95.0499C142.229 91.3411 139.223 88.3344 135.514 88.3344Z",
    fill: "#EFE8E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1559 74.4047H31.3795C28.7722 74.4047 26.6582 76.5187 26.6582 79.1259V88.3335H94.5477L88.3022 76.867C87.4756 75.3493 85.8845 74.4047 84.1559 74.4047Z",
    fill: "#985AFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.88 81.3691C45.88 83.2258 44.3744 84.7315 42.5177 84.7315C40.6609 84.7315 39.1553 83.2258 39.1553 81.3691C39.1553 79.5124 40.6609 78.0067 42.5177 78.0067C44.3744 78.0067 45.88 79.5124 45.88 81.3691Z",
    stroke: "white",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.007 81.3691C60.007 83.2258 58.5014 84.7315 56.6446 84.7315C54.7879 84.7315 53.2822 83.2258 53.2822 81.3691C53.2822 79.5124 54.7879 78.0067 56.6446 78.0067C58.5014 78.0067 60.007 79.5124 60.007 81.3691Z",
    stroke: "white",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M74.133 81.3691C74.133 83.2258 72.6273 84.7315 70.7706 84.7315C68.9129 84.7315 67.4082 83.2258 67.4082 81.3691C67.4082 79.5124 68.9138 78.0067 70.7706 78.0067C72.6273 78.0067 74.133 79.5124 74.133 81.3691Z",
    stroke: "white",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M143.608 206.269H45.4919C41.8675 206.269 38.9287 203.332 38.9287 199.706V197.846C38.9287 194.222 41.8666 191.283 45.4919 191.283H143.608C147.232 191.283 150.171 194.222 150.171 197.846V199.706C150.17 203.332 147.232 206.269 143.608 206.269Z",
    fill: "#E2DDDE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.608 242.779H45.4919C41.8675 242.779 38.9287 239.841 38.9287 236.216V220.201C38.9287 216.577 41.8666 213.638 45.4919 213.638H143.608C147.232 213.638 150.171 216.576 150.171 220.201V236.216C150.17 239.84 147.232 242.779 143.608 242.779Z",
    fill: "#E2DDDE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M138.377 209.963H40.2614C36.6371 209.963 33.6982 207.025 33.6982 203.399V201.539C33.6982 197.915 36.6361 194.976 40.2614 194.976H138.377C142.001 194.976 144.94 197.914 144.94 201.539V203.399C144.94 207.025 142.001 209.963 138.377 209.963Z",
    fill: "#EFE8E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M138.377 246.472H40.2614C36.6371 246.472 33.6982 243.534 33.6982 239.909V223.894C33.6982 220.27 36.6361 217.331 40.2614 217.331H138.377C142.001 217.331 144.94 220.269 144.94 223.894V239.909C144.94 243.533 142.001 246.472 138.377 246.472Z",
    fill: "#EFE8E9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3565 198.777C52.3565 201.674 50.0084 204.022 47.1113 204.022C44.2143 204.022 41.8662 201.674 41.8662 198.777C41.8662 195.879 44.2143 193.531 47.1113 193.531C50.0075 193.531 52.3565 195.879 52.3565 198.777Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3565 221.964C52.3565 224.861 50.0084 227.209 47.1113 227.209C44.2143 227.209 41.8662 224.861 41.8662 221.964C41.8662 219.067 44.2143 216.719 47.1113 216.719C50.0075 216.719 52.3565 219.067 52.3565 221.964Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5479 198.777H141.698",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2871 198.777H71.9107",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5498 221.5H141.7",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2871 221.5H71.9107",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.189 228.209H141.699",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2871 228.209H108.551",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2041 234.917H141.7",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2871 234.917H92.5652",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5439 203.426L52.1017 194.128",
    stroke: "#E15938",
    strokeWidth: 1.85767,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6738 193.998L51.9724 203.555",
    stroke: "#E15938",
    strokeWidth: 1.85767,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5439 219.493L47.255 224.702L55.5792 214.285",
    stroke: "#94C19B",
    strokeWidth: 1.85767,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4436 183.003C102.61 183.003 117.336 168.277 117.336 150.11C117.336 131.944 102.61 117.218 84.4436 117.218C66.2774 117.218 51.5508 131.944 51.5508 150.11C51.5508 168.277 66.2774 183.003 84.4436 183.003Z",
    fill: "#F7F3F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9231_28168",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 117,
    width: 67,
    height: 67
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4456 183.003C102.612 183.003 117.338 168.277 117.338 150.11C117.338 131.944 102.612 117.218 84.4456 117.218C66.2794 117.218 51.5527 131.944 51.5527 150.11C51.5527 168.277 66.2794 183.003 84.4456 183.003Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9231_28168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.3286 125.324C73.7264 124.781 69.9627 129.124 69.9627 140.224C69.9627 151.324 70.3491 154.219 65.1365 156.342C59.9248 158.465 55.6782 165.415 64.268 170.144C72.8579 174.873 100.172 170.144 100.172 170.144L98.8068 136.372L88.3286 125.324Z",
    fill: "#AFA59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8808 157.641C107.076 162.21 110.032 185.501 110.032 185.501L92.71 188.096L97.8808 157.641Z",
    fill: "#DACCC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8803 157.642L97.4883 164.064L96.7211 176.612L96.6097 178.433L96.2548 184.204L95.8099 191.458H71.7113L71.6899 191.24L68.9796 159.644L68.8105 157.642L75.8465 155.763L88.0922 152.486L94.7362 155.986C94.7362 155.992 94.7362 155.992 94.7362 155.992L97.8803 157.642Z",
    fill: "#DACCC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8477 155.762L88.0934 152.487L94.7374 155.985C94.7374 155.989 94.7374 155.989 94.7374 155.989C95.2139 169.142 81.2089 166.096 75.8477 155.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6062 158.947L81.4345 158.936C79.5406 158.933 78.0089 157.395 78.0117 155.501L78.034 145.255L90.303 145.277L90.2807 155.284C90.277 157.31 88.632 158.949 86.6062 158.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2861 152.762L90.2842 154.587C85.0716 155.126 79.3203 151.649 80.9253 143.372L90.3019 143.387L90.2861 152.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7977 125.372C92.7358 124.755 98.0487 129.07 98.6655 135.008L99.0333 138.551C99.6027 144.04 95.6161 148.95 90.1276 149.52L80.2513 150.545C79.3178 150.642 78.4828 149.964 78.3853 149.03L77.1611 137.24C76.5452 131.302 80.8597 125.989 86.7977 125.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8273 140.473C78.8273 140.473 85.3134 134.963 88.3284 125.324C71.5109 123.985 71.3297 139.033 78.8273 140.473Z",
    fill: "#AFA59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3994 141.476C78.7885 136.555 76.4255 136.217 74.5186 137.215C71.0234 139.043 72.5486 147.373 79.0198 145.607L81.3994 141.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4443 125.314C84.4443 125.314 95.3637 124.442 98.8069 136.372C98.9072 126.189 92.2986 124.15 84.4443 125.314Z",
    fill: "#AFA59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7052 164.284C62.147 169.326 61.3036 185.743 62.4674 199.017L72.7422 194.979C80.4469 162.106 72.5778 156.637 72.5778 156.637C72.5778 156.637 63.4892 157.205 62.7052 164.284Z",
    fill: "#DACCC8"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M127.384 106.162H41.5039",
    stroke: "#EFE8E9",
    strokeWidth: 7.43068,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M396.692 99.9727H355.581L349.335 88.5062C348.509 86.9876 346.918 86.043 345.189 86.043H292.413C289.805 86.043 287.691 88.157 287.691 90.7642V99.9718V259.567C287.691 263.196 290.633 266.138 294.262 266.138H396.693C400.322 266.138 403.264 263.196 403.264 259.567V106.543C403.262 102.914 400.32 99.9727 396.692 99.9727Z",
    fill: "#EFE8E9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M303.923 254.034C300.476 254.034 297.672 251.229 297.672 247.783V88.7988H406.063C409.51 88.7988 412.314 91.603 412.314 95.0499V247.783C412.314 251.23 409.509 254.033 406.063 254.033H303.923V254.034Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M406.062 89.2633C409.253 89.2633 411.849 91.8594 411.849 95.05V247.783C411.849 250.974 409.252 253.57 406.062 253.57H303.923C300.732 253.57 298.136 250.974 298.136 247.783V89.2633H406.062ZM406.062 88.3345H297.207V247.783C297.207 251.492 300.214 254.498 303.923 254.498H406.062C409.771 254.498 412.777 251.492 412.777 247.783V95.05C412.778 91.3411 409.772 88.3345 406.062 88.3345Z",
    fill: "#EFE8E9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M354.705 74.4047H301.928C299.321 74.4047 297.207 76.5187 297.207 79.1259V88.3335H365.097L358.851 76.867C358.023 75.3493 356.433 74.4047 354.705 74.4047Z",
    fill: "#985AFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M316.43 81.369C316.43 83.2257 314.924 84.7314 313.067 84.7314C311.211 84.7314 309.705 83.2257 309.705 81.369C309.705 79.5122 311.211 78.0066 313.067 78.0066C314.924 78.0066 316.43 79.5122 316.43 81.369Z",
    stroke: "white",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M330.557 81.369C330.557 83.2257 329.051 84.7314 327.194 84.7314C325.338 84.7314 323.832 83.2257 323.832 81.369C323.832 79.5122 325.338 78.0066 327.194 78.0066C329.051 78.0066 330.557 79.5122 330.557 81.369Z",
    stroke: "white",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M344.683 81.369C344.683 83.2257 343.177 84.7314 341.32 84.7314C339.464 84.7314 337.958 83.2257 337.958 81.369C337.958 79.5122 339.464 78.0066 341.32 78.0066C343.177 78.0066 344.683 79.5122 344.683 81.369Z",
    stroke: "white",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M414.154 206.27H316.04C312.415 206.27 309.477 203.332 309.477 199.706V197.846C309.477 194.222 312.414 191.283 316.04 191.283H414.155C417.78 191.283 420.719 194.222 420.719 197.846V199.706C420.718 203.332 417.78 206.27 414.154 206.27Z",
    fill: "#E2DDDE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M414.154 242.779H316.04C312.415 242.779 309.477 239.841 309.477 236.216V220.201C309.477 216.577 312.415 213.638 316.04 213.638H414.155C417.78 213.638 420.719 216.576 420.719 220.201V236.216C420.718 239.841 417.78 242.779 414.154 242.779Z",
    fill: "#E2DDDE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M408.925 209.963H310.809C307.185 209.963 304.246 207.025 304.246 203.399V201.539C304.246 197.915 307.185 194.976 310.809 194.976H408.925C412.549 194.976 415.488 197.914 415.488 201.539V203.399C415.488 207.025 412.549 209.963 408.925 209.963Z",
    fill: "#EFE8E9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M408.925 246.472H310.809C307.185 246.472 304.246 243.534 304.246 239.909V223.894C304.246 220.27 307.185 217.331 310.809 217.331H408.925C412.549 217.331 415.488 220.269 415.488 223.894V239.909C415.488 243.534 412.549 246.472 408.925 246.472Z",
    fill: "#EFE8E9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M317.658 204.022C320.555 204.022 322.903 201.673 322.903 198.777C322.903 195.88 320.555 193.531 317.658 193.531C314.761 193.531 312.413 195.88 312.413 198.777C312.413 201.673 314.761 204.022 317.658 204.022Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M317.658 227.209C320.555 227.209 322.903 224.861 322.903 221.964C322.903 219.067 320.555 216.719 317.658 216.719C314.761 216.719 312.413 219.067 312.413 221.964C312.413 224.861 314.761 227.209 317.658 227.209Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M348.098 198.777H412.248",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M327.835 198.777H342.458",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M348.097 221.5H412.247",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M327.835 221.5H342.458",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M384.737 228.209H412.247",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M327.835 228.209H379.099",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M368.751 234.917H412.246",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M327.835 234.917H363.113",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M313.094 195.837L317.805 201.045L326.129 190.628",
    stroke: "#94C19B",
    strokeWidth: 1.85767,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M313.093 226.614L322.65 217.315",
    stroke: "#E15938",
    strokeWidth: 1.85767,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M313.223 217.185L322.521 226.743",
    stroke: "#E15938",
    strokeWidth: 1.85767,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M397.935 106.162H312.056",
    stroke: "#EFE8E9",
    strokeWidth: 7.43068,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M360.283 182.554C378.211 179.627 390.372 162.721 387.446 144.793C384.519 126.865 367.613 114.703 349.685 117.63C331.756 120.556 319.595 137.463 322.522 155.391C325.448 173.319 342.354 185.48 360.283 182.554Z",
    fill: "#F7F3F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9231_28168",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 322,
    y: 117,
    width: 66,
    height: 66
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M360.283 182.554C378.211 179.627 390.372 162.721 387.446 144.793C384.519 126.865 367.613 114.703 349.685 117.63C331.756 120.556 319.595 137.463 322.522 155.391C325.448 173.319 342.354 185.48 360.283 182.554Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9231_28168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.13 163.042L355.833 165.318C355.845 165.535 355.965 167.684 356.301 170.645C356.8 174.999 357.76 181.089 359.514 185.352C359.911 186.307 360.721 187.581 361.862 188.974L373.383 178.91C371.912 176.591 369.897 172.435 369.171 169.113C368.907 167.888 367.783 166.075 366.204 164.717C365.423 164.038 364.529 163.474 363.567 163.156C363.531 163.138 363.484 163.12 363.448 163.114C363.351 163.09 363.261 163.06 363.171 163.03L363.13 163.042Z",
    fill: "#AFA59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.929 171.533C334.929 171.569 334.936 171.605 334.941 171.635C335.326 174.373 335.884 177.13 336.587 179.797C337.837 184.517 339.56 188.973 341.638 192.606C342.455 194.029 343.326 195.333 344.245 196.474C344.389 196.648 344.533 196.822 344.677 196.991L345.47 196.119L345.65 195.921L362.46 199.187L365.155 174.573L366.261 173.367C366.729 171.649 367.018 170.31 367.167 169.223C367.36 167.745 366.969 166.305 366.152 165.163C365.9 164.809 365.606 164.478 365.275 164.19C365.234 164.153 365.185 164.112 365.143 164.075C364.579 163.607 363.913 163.247 363.173 163.03C363.156 163.024 363.144 163.024 363.125 163.018C357.39 161.337 347.241 159.596 343.728 159.031C343.541 159.001 343.38 158.97 343.229 158.947C342.779 158.875 342.515 158.833 342.491 158.833C340.335 158.634 338.708 158.953 337.507 159.698C335.795 160.748 334.954 162.652 334.684 165.097C334.472 166.969 334.599 169.161 334.929 171.533Z",
    fill: "#AFA59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.538 141.051C374.311 137.278 374.311 131.162 370.538 127.39C366.766 123.617 360.65 123.617 356.877 127.39C353.105 131.162 353.105 137.278 356.877 141.051C360.65 144.823 366.766 144.823 370.538 141.051Z",
    fill: "#AFA59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.971 140.031C362.375 136.627 362.375 131.108 358.971 127.704C355.567 124.3 350.049 124.3 346.645 127.704C343.241 131.108 343.241 136.627 346.645 140.031C350.049 143.435 355.567 143.435 358.971 140.031Z",
    fill: "#AFA59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.07 141.921C358.844 137.17 355.619 132.691 350.868 131.917C346.117 131.144 341.638 134.368 340.865 139.119C340.091 143.871 343.316 148.349 348.067 149.123C352.818 149.897 357.297 146.672 358.07 141.921Z",
    fill: "#AFA59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.747 141.353C372.817 134.839 368.484 124.982 354.848 130.897L369.747 141.353Z",
    fill: "#AFA59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.569 163.16C361.982 170.765 347.658 167.61 346.195 159.754L354.188 159.764L362.569 163.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.397 164.339L347.458 161.775L350.559 144.481L363.498 147.044L360.397 164.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.996 160.996L358.117 160.48C355.326 159.979 353.47 157.312 353.97 154.521L355.566 145.621L363.497 147.043L360.996 160.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.445 143.222V156.957H362.676C366.987 156.957 370.555 153.822 371.227 149.703C371.305 149.24 371.347 148.766 371.347 148.285V143.223C371.347 142.694 371.311 142.178 371.233 141.674C371.089 140.635 370.795 139.65 370.368 138.726C368.656 134.924 364.837 132.276 360.393 132.276C360.118 132.276 359.835 132.288 359.571 132.305C355.487 132.612 352.027 135.158 350.412 138.726C350.004 139.651 349.709 140.635 349.565 141.674C349.482 142.177 349.445 142.694 349.445 143.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.726 131.355C363.52 138.771 353.888 137.564 353.888 137.564C353.888 137.564 355.351 143.085 352.911 146.638L347.423 143.378L350.437 131.511L364.726 131.355Z",
    fill: "#AFA59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.164 146.3C350.239 141.798 347.942 141.675 346.196 142.795C344.024 144.188 344.299 148.536 347.043 150.313C349.441 151.866 352.651 150.175 353.025 147.342L353.164 146.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.187 177.373L340.028 179.981C345.344 163.731 340.582 158.774 340.582 158.774C340.582 158.774 338.004 159.028 336.179 160.101C333.214 161.836 331.81 164.073 329.747 169.288C328.926 171.367 328.076 173.998 327.187 177.373Z",
    fill: "#AFA59E"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M261.237 99.9725H220.126L213.88 88.5061C213.054 86.9874 211.463 86.0428 209.734 86.0428H156.958C154.35 86.0428 152.236 88.1568 152.236 90.764V99.9716V259.567C152.236 263.196 155.178 266.137 158.807 266.137H261.237C264.866 266.137 267.808 263.196 267.808 259.567V106.543C267.808 102.914 264.866 99.9725 261.237 99.9725Z",
    fill: "#EFE8E9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M167.554 257.387C164.107 257.387 161.303 254.582 161.303 251.136V92.1518H269.694C273.141 92.1518 275.945 94.956 275.945 98.4029V251.137C275.945 254.584 273.14 257.387 269.694 257.387H167.554Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M269.693 92.6162C272.883 92.6162 275.479 95.2123 275.479 98.4029V251.136C275.479 254.327 272.883 256.923 269.693 256.923H167.553C164.362 256.923 161.767 254.326 161.767 251.136V92.6162H269.693ZM269.693 91.6874H160.837V251.136C160.837 254.845 163.844 257.851 167.552 257.851H269.692C273.401 257.851 276.407 254.845 276.407 251.136V98.4029C276.409 94.694 273.402 91.6874 269.693 91.6874Z",
    fill: "#EFE8E9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M218.335 77.7577H165.558C162.951 77.7577 160.837 79.8717 160.837 82.479V91.6865H228.726L222.481 80.22C221.654 78.7023 220.064 77.7577 218.335 77.7577Z",
    fill: "#985AFF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M180.059 84.723C180.059 86.5797 178.553 88.0854 176.696 88.0854C174.84 88.0854 173.334 86.5797 173.334 84.723C173.334 82.8653 174.84 81.3606 176.696 81.3606C178.553 81.3606 180.059 82.8653 180.059 84.723Z",
    stroke: "white",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M194.186 84.723C194.186 86.5797 192.68 88.0854 190.823 88.0854C188.967 88.0854 187.461 86.5797 187.461 84.723C187.461 82.8653 188.967 81.3606 190.823 81.3606C192.681 81.3606 194.186 82.8653 194.186 84.723Z",
    stroke: "white",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M208.313 84.723C208.313 86.5797 206.807 88.0854 204.95 88.0854C203.094 88.0854 201.588 86.5797 201.588 84.723C201.588 82.8653 203.094 81.3606 204.95 81.3606C206.807 81.3606 208.313 82.8653 208.313 84.723Z",
    stroke: "white",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M277.783 209.624H179.668C176.043 209.624 173.104 206.686 173.104 203.061V201.2C173.104 197.576 176.042 194.637 179.668 194.637H277.783C281.408 194.637 284.346 197.575 284.346 201.2V203.061C284.346 206.685 281.408 209.624 277.783 209.624Z",
    fill: "#E2DDDE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M277.783 246.132H179.668C176.043 246.132 173.104 243.195 173.104 239.569V223.554C173.104 219.93 176.042 216.991 179.668 216.991H277.783C281.408 216.991 284.346 219.929 284.346 223.554V239.569C284.346 243.195 281.408 246.132 277.783 246.132Z",
    fill: "#E2DDDE"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M272.554 213.317H174.438C170.814 213.317 167.875 210.378 167.875 206.754V204.893C167.875 201.269 170.813 198.33 174.438 198.33H272.554C276.178 198.33 279.117 201.268 279.117 204.893V206.754C279.116 210.378 276.178 213.317 272.554 213.317Z",
    fill: "#EFE8E9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M272.554 249.826H174.438C170.814 249.826 167.875 246.887 167.875 243.262V227.247C167.875 223.623 170.813 220.684 174.438 220.684H272.554C276.178 220.684 279.117 223.622 279.117 227.247V243.262C279.116 246.888 276.178 249.826 272.554 249.826Z",
    fill: "#EFE8E9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M181.287 207.375C184.184 207.375 186.532 205.027 186.532 202.13C186.532 199.233 184.184 196.885 181.287 196.885C178.39 196.885 176.042 199.233 176.042 202.13C176.042 205.027 178.39 207.375 181.287 207.375Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M181.287 230.563C184.184 230.563 186.532 228.215 186.532 225.318C186.532 222.421 184.184 220.073 181.287 220.073C178.39 220.073 176.042 222.421 176.042 225.318C176.042 228.215 178.39 230.563 181.287 230.563Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M211.726 202.13H275.877",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M191.464 202.13H206.087",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M211.726 224.853H275.877",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M191.464 224.853H206.087",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M248.367 231.562H275.877",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M191.464 231.562H242.729",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M232.381 238.271H275.876",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M191.464 238.271H226.743",
    stroke: "#BAAEAF",
    strokeWidth: 0.464418,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M176.723 199.19L181.434 204.398L189.758 193.982",
    stroke: "#94C19B",
    strokeWidth: 1.85767,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M176.723 222.199L181.434 227.408L189.758 216.991",
    stroke: "#94C19B",
    strokeWidth: 1.85767,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M261.563 109.515H175.684",
    stroke: "#EFE8E9",
    strokeWidth: 7.43068,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M244.894 197.442C274.909 192.539 295.266 164.233 290.364 134.218C285.461 104.204 257.155 83.8461 227.14 88.7487C197.126 93.6513 176.768 121.957 181.671 151.972C186.573 181.987 214.88 202.344 244.894 197.442Z",
    fill: "#F7F3F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9231_28168",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 88,
    width: 112,
    height: 111
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M244.893 197.442C274.908 192.539 295.265 164.233 290.363 134.218C285.46 104.204 257.154 83.8462 227.139 88.7488C197.125 93.6514 176.767 121.957 181.67 151.972C186.573 181.987 214.879 202.344 244.893 197.442Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9231_28168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.235 157.87C191.405 166.869 195.557 188.908 195.557 188.908C195.557 188.908 233.579 206.221 261.039 192.279C259.349 165.241 243.464 160.567 243.464 160.567L205.235 157.87Z",
    fill: "#E15938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.332 242.468L212.847 242.543L197.051 242.572C197.051 242.572 199.929 235.595 202.439 226.379C204.546 218.636 206.394 209.322 206.06 201.24C205.864 196.41 205.23 191.333 205.237 186.129C205.242 182.824 192.74 166.51 205.237 157.87C211.812 153.324 229.869 152.251 228.77 153.287L243.466 160.567C249.722 163.667 253.302 170.307 252.705 177.264C252.596 178.529 252.627 179.834 252.891 181.149C252.995 181.616 253.08 182.105 253.161 182.583C253.409 184.212 253.57 185.875 253.552 187.58C253.557 188.051 253.546 188.553 253.483 189.054C253.454 189.774 253.374 190.521 253.253 191.247C252.556 195.553 250.553 199.83 246.356 203.583L246.419 203.871L246.43 203.935L249.211 214.745L252.003 225.619L252.078 225.907L256.332 242.468Z",
    fill: "#E15938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.434 117.784C263.434 123.048 259.167 127.316 253.903 127.316C248.638 127.316 244.371 123.049 244.371 117.784C244.371 112.52 248.638 108.253 253.903 108.253C259.167 108.253 263.434 112.52 263.434 117.784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.692 107.782C254.127 102.536 250.227 97.9301 244.98 97.4953C239.734 97.0605 235.128 100.961 234.694 106.207C234.259 111.454 238.159 116.059 243.406 116.494C248.652 116.929 253.257 113.028 253.692 107.782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.063 112.448C242.16 107.299 238.874 102.237 233.726 101.14C228.577 100.043 223.514 103.329 222.417 108.478C221.321 113.626 224.606 118.689 229.755 119.786C234.904 120.882 239.966 117.597 241.063 112.448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.774 116.291C215.925 126.15 217.286 132.427 223.504 136.525L229.394 130.099L225.871 114.638L219.774 116.291Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.105 130.099L225.344 154.109L243.227 166.195L243.48 136.594L223.105 130.099Z",
    fill: "#89482F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.185 136.81L224.423 144.212L227.075 138.571L220.185 136.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.314 156.084C243.314 156.084 232.284 154.094 231.964 141.644L243.481 145.395L243.314 156.084Z",
    fill: "#5E1E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.687 112.62C256.021 119.159 256.721 127.773 256.721 127.773L250.938 128.687L246.544 114.834L250.687 112.62Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.916 120.279L226.637 127.09L227.425 130.194L229.536 138.529C230.674 143.028 234.063 146.617 238.489 148.013L245.37 150.184C251.335 152.066 257.469 147.924 258.025 141.694C258.433 137.123 258.43 131.789 256.689 126.122C254.664 119.54 249.386 114.397 243.105 112.344L243.079 112.337L241.976 112.007L241.858 111.977C241.307 111.833 240.74 111.715 240.174 111.622C238.83 111.384 237.441 111.281 236.037 111.322L231.586 111.452C227.053 111.584 223.806 115.881 224.916 120.279Z",
    fill: "#89482F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.764 131.031C253.764 132.671 253.158 134 252.41 134C251.662 134 251.057 132.671 251.057 131.031C251.057 129.392 251.662 128.063 252.41 128.063C253.159 128.062 253.764 129.391 253.764 131.031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.354 129.078C250.847 132.671 253.314 133.411 255.028 133.435C256.129 133.451 257.032 134.302 257.121 135.399C257.237 136.846 256.49 138.225 255.215 138.919L250.703 141.373C248.173 142.219 245.465 140.703 244.862 138.104L242.819 129.295L249.354 129.078Z",
    fill: "#89482F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.369 140.795L252.095 140.289L255.077 138.666C256.251 138.028 256.94 136.755 256.833 135.422C256.756 134.467 255.979 133.737 255.024 133.723C253.165 133.696 250.626 132.888 249.088 129.188L249.62 128.967C251.038 132.378 253.346 133.123 255.032 133.147C256.285 133.166 257.307 134.124 257.407 135.375C257.533 136.935 256.726 138.425 255.352 139.171L252.369 140.795Z",
    fill: "#5E1E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.764 131.55C243.764 133.19 243.158 134.519 242.41 134.519C241.662 134.519 241.056 133.19 241.056 131.55C241.056 129.911 241.661 128.582 242.409 128.582C243.158 128.582 243.763 129.91 243.764 131.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.973 124.402C237.263 125.95 236.244 124.045 238.905 122.432C241.768 120.698 245.591 122.478 240.973 124.402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.665 122.664C248.771 122.194 249.574 120.373 251.995 120.345C254.599 120.314 255.266 123.248 251.665 122.664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.716 142.003L244.039 141.488C244.039 141.488 244.79 145.345 246.728 145.762C248.835 146.217 250.716 142.003 250.716 142.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.547 111.38C238.05 119.656 231.455 130.977 217.623 130.153C211.8 118.388 212.048 107.866 234.547 111.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.795 131.074C215.906 111.991 208.692 142.209 229.106 140.624L229.795 131.074Z",
    fill: "#89482F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.647 118.852L229.906 134.881L228.563 135.779L223.506 120.367L229.647 118.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.412 113.111C241.516 117.46 251.632 113.865 251.632 113.865C251.632 113.865 247.946 104.988 230.412 113.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.377 114.93C216.377 109.287 210.145 111.992 214.424 115.646C206.92 114.633 212.6 123.939 216.056 120.684",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.916 166.51C246.326 153.416 234.006 150.642 224.699 146.817L219.58 153.401L243.916 166.51Z",
    fill: "white"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M107.05 200.42C103.719 201.7 100.149 200.896 97.6564 198.722C96.3421 197.572 95.326 196.04 94.8114 194.226C93.6494 190.144 95.4031 185.952 98.7794 183.807C99.6627 183.245 100.66 182.822 101.746 182.579L140.991 173.79L141.044 173.775L143.192 179.744C143.192 179.744 129.032 191.976 107.05 200.42Z",
    fill: "#E89E91"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M137.358 183.34C131.276 187.664 120.612 194.405 106.892 199.681C103.555 200.956 99.9899 200.153 97.495 197.979C96.1779 196.823 95.1627 195.293 94.6472 193.482C93.489 189.399 95.2445 185.207 98.6217 183.067C99.5041 182.505 100.498 182.074 101.587 181.839L135.132 174.324L137.358 183.34Z",
    fill: "#A584F1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M150.298 186.229C148.546 180.92 145.512 178.467 139.931 178.862C139.931 178.862 146.671 179.376 150.298 186.229Z",
    fill: "#E89E91"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M156.381 196.414L172.684 179.559L152.704 183.363L150.65 198.5L156.381 196.414Z",
    fill: "#F2C7BF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M158.291 185.162L172.682 179.562L172.77 179.086C173.111 177.217 174.254 175.594 175.9 174.65C176.163 174.495 176.29 174.191 176.225 173.908C176.215 173.864 176.197 173.82 176.179 173.777C175.668 172.645 174.443 172.063 173.278 172.33C173.084 172.375 172.897 172.449 172.705 172.54L171.882 173.028L171.799 173.078C170.383 173.922 169.473 175.404 169.364 177.048L158.643 184.908L158.291 185.162Z",
    fill: "#F2C7BF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M163.959 184.648L170.275 180.901C170.636 177.795 172.037 176.34 173.683 175.396C173.946 175.241 174.073 174.937 174.007 174.654C173.997 174.609 173.979 174.566 173.962 174.523C173.573 173.654 172.757 173.11 171.882 173.029L171.799 173.079C170.383 173.923 169.473 175.405 169.364 177.049L168.727 180.469L163.959 184.648Z",
    fill: "#E89E91"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M168.725 180.468L168.812 179.995C169.152 178.128 170.296 176.506 171.94 175.56C172.244 175.385 172.366 175.008 172.221 174.687C171.624 173.364 170.047 172.8 168.747 173.446L167.841 173.986C166.426 174.831 165.514 176.316 165.402 177.96L154.332 186.071L168.725 180.468Z",
    fill: "#F2C7BF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1423 202.802L93.0947 207.528C93.6957 208.984 95.3638 209.677 96.8193 209.076L187.397 171.665C188.853 171.064 189.546 169.397 188.945 167.941L186.993 163.214C186.393 161.758 184.725 161.065 183.269 161.666L92.6907 199.077C91.2342 199.679 90.5413 201.346 91.1423 202.802Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M230.021 87.208C199.028 90.1042 176.107 121.343 179.003 152.336C181.897 183.317 209.356 206.094 240.35 203.198C271.331 200.303 294.107 172.833 291.213 141.851C288.316 110.859 261.002 84.3138 230.021 87.208ZM229.754 89.7911C259.19 87.0409 285.292 108.683 288.044 138.131C290.795 167.567 269.153 193.669 239.717 196.421C210.268 199.172 184.166 177.53 181.416 148.094C178.664 118.645 200.306 92.5433 229.754 89.7911Z",
    fill: "#AFA59E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M180.504 179.792L172.998 162.806C172.338 161.312 173.014 159.566 174.508 158.907L176.933 157.835C178.426 157.174 180.173 157.851 180.832 159.344L188.338 176.33C188.998 177.823 188.322 179.57 186.829 180.229L184.403 181.301C182.91 181.961 181.164 181.285 180.504 179.792Z",
    fill: "#AFA59E"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M179.023 176.439L172.998 162.806C172.338 161.312 173.014 159.566 174.508 158.907L176.933 157.835C178.426 157.174 180.173 157.851 180.832 159.344L186.857 172.978C187.517 174.471 186.841 176.216 185.347 176.877L182.922 177.949C181.428 178.608 179.682 177.933 179.023 176.439Z",
    fill: "#EFE8E9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M231.081 91.9572C202.402 94.6369 180.505 120.421 183.185 149.101C185.864 177.769 212.104 198.483 240.784 195.803C269.452 193.124 290.529 167.703 287.85 139.035C285.17 110.356 259.749 89.2793 231.081 91.9572Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9231_28168",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 91,
    width: 107,
    height: 106
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M231.082 91.9572C202.402 94.6369 180.497 120.363 183.177 149.042C185.856 177.71 212.105 198.483 240.784 195.803C269.452 193.124 290.529 167.703 287.85 139.035C285.171 110.356 259.749 89.2793 231.082 91.9572Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9231_28168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.112 79.3965L163.775 101.085L281.768 206.287L301.106 184.599L183.112 79.3965Z",
    fill: "url(#paint0_linear_9231_28168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.351 107.168L146.846 120.072L264.839 225.275L276.344 212.37L158.351 107.168Z",
    fill: "url(#paint1_linear_9231_28168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.691 57.4388L191.186 70.3431L309.179 175.546L320.684 162.641L202.691 57.4388Z",
    fill: "url(#paint2_linear_9231_28168)"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M235.63 198.905C221.365 198.904 207.665 193.607 197.052 183.99C186.372 174.312 179.752 161.075 178.41 146.716C175.459 115.127 198.757 87.0269 230.346 84.075C232.146 83.9069 233.969 83.8215 235.766 83.8215C250.027 83.8215 263.728 89.1168 274.341 98.7311C285.022 108.408 291.645 121.647 292.986 136.01C295.938 167.599 272.64 195.7 241.051 198.651C239.251 198.819 237.429 198.904 235.633 198.904C235.631 198.905 235.63 198.905 235.63 198.905ZM235.757 87.8173C234.086 87.8173 232.391 87.8963 230.717 88.0523C201.321 90.7989 179.641 116.948 182.388 146.343C183.636 159.703 189.797 172.018 199.737 181.021C209.614 189.969 222.362 194.896 235.635 194.896C237.307 194.896 239.004 194.816 240.679 194.661C270.067 191.915 291.742 165.772 288.997 136.383C287.747 123.019 281.587 110.7 271.647 101.694C261.772 92.7457 249.025 87.8173 235.757 87.8173Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M235.767 84.2859C249.913 84.2859 263.501 89.5385 274.029 99.0757C284.625 108.674 291.193 121.807 292.524 136.054C295.452 167.387 272.342 195.261 241.008 198.189C239.223 198.356 237.413 198.441 235.63 198.441C221.482 198.441 207.893 193.187 197.364 183.647C186.771 174.048 180.204 160.918 178.873 146.673C175.945 115.34 199.056 87.4653 230.389 84.5376C232.174 84.3704 233.984 84.2859 235.767 84.2859ZM235.635 195.361C237.322 195.361 239.033 195.281 240.721 195.123C255.078 193.782 268.055 186.928 277.262 175.824C286.468 164.719 290.8 150.698 289.458 136.341C288.199 122.861 281.984 110.434 271.959 101.35C261.997 92.324 249.141 87.3529 235.757 87.3538C234.072 87.3538 232.362 87.4337 230.674 87.5916C216.311 88.9338 203.33 95.7886 194.123 106.894C184.915 117.999 180.584 132.025 181.925 146.389C183.184 159.863 189.399 172.287 199.424 181.368C209.387 190.39 222.247 195.361 235.635 195.361ZM235.767 83.3571C233.96 83.3571 232.138 83.4407 230.303 83.6125C198.401 86.5931 174.967 114.857 177.948 146.758C180.756 176.813 206.026 199.369 235.629 199.369C237.436 199.369 239.258 199.285 241.094 199.113C272.984 196.133 296.428 167.857 293.449 135.967C290.64 105.902 265.362 83.3571 235.767 83.3571ZM235.635 194.432C208.548 194.432 185.42 173.798 182.85 146.301C180.123 117.114 201.573 91.2419 230.761 88.5149C232.438 88.3579 234.104 88.2817 235.757 88.2817C262.834 88.2817 285.963 108.918 288.534 136.427C291.26 165.602 269.81 191.473 240.636 194.199C238.958 194.355 237.288 194.432 235.635 194.432Z",
    fill: "#EFE8E9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M122.648 196.069L150.818 192.895L156.55 196.279C156.55 196.279 140.501 210.75 122.727 214.393C110.506 216.9 106.781 198.846 122.648 196.069Z",
    fill: "#F2C7BF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M150.911 185.293L148.205 194.199L153.909 195.381L159.104 191.183L154.927 184.727C154.539 184.126 153.886 183.748 153.172 183.709C152.143 183.654 151.21 184.307 150.911 185.293Z",
    fill: "#F2C7BF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M122.647 196.069L145.154 192.89L149.635 203.106C149.635 203.106 139.927 212.835 122.153 216.479C109.93 218.985 106.78 198.846 122.647 196.069Z",
    fill: "#B0A2F3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M151.817 177.363C147.696 180.805 140.222 179.094 136.465 175.33C139.398 172.234 144.763 172.314 152.661 174.716L151.817 177.363Z",
    fill: "#E89E91"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M151.826 186.692L152.16 186.884C152.986 187.361 154.043 187.079 154.521 186.252L157.382 181.302C157.859 180.476 157.577 179.42 156.75 178.942L156.416 178.75C155.59 178.273 154.534 178.555 154.056 179.382L151.196 184.331C150.717 185.157 151 186.214 151.826 186.692Z",
    fill: "#F2C7BF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M143.776 174.967L143.763 175.635C143.746 176.511 144.444 177.234 145.32 177.251L156.024 177.452C156.9 177.468 157.623 176.771 157.639 175.895L157.651 175.226C157.668 174.35 156.971 173.628 156.095 173.611L145.391 173.41C144.515 173.393 143.792 174.09 143.776 174.967Z",
    fill: "#E89E91"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6146 361.953C32.6146 361.953 19.9954 377.051 18.8009 387.614C18.0765 394.02 27.2478 393.699 37.9034 393.62L61.6388 393.446C64.3222 393.426 65.3765 389.939 63.1426 388.452C62.1785 387.811 60.7806 387.359 58.7594 387.319C58.7594 387.319 53.5496 382.488 41.1952 377.548C41.1952 377.548 40.0369 363.108 45.2087 354.11L32.6146 361.953Z",
    fill: "#E89E91"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4404 379.198L51.9304 305.742H75.5637L41.1958 377.548L21.4404 379.198Z",
    fill: "#E89E91"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0195 262.074L105.856 307.182H86.006L70.8232 262.074H98.0195Z",
    fill: "#F2C7BF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M134.121 389.293C135.796 390.84 134.563 393.665 132.283 393.648C127.116 393.609 116.742 393.531 109.35 393.472C106.27 393.451 103.322 393.444 100.724 393.285C100.006 393.243 99.3089 393.188 98.6532 393.112C93.7852 392.594 90.6494 391.206 91.1333 387.436C91.5894 383.921 91.5132 380.772 91.2234 378.169C91.1686 377.637 91.099 377.119 91.0228 376.635C90.4218 372.685 87.5703 336.515 87.5703 336.515L106.81 356.184L108.203 375.497C119.971 380.407 129.425 387.733 129.425 387.733C131.759 387.816 133.217 388.459 134.121 389.293Z",
    fill: "#F2C7BF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M108.323 376.408L109.534 308.041L89.7129 306.981L91.2241 378.169L108.323 376.408Z",
    fill: "#F2C7BF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1375 139.32L88.2831 168.513L72.335 161.146L75.297 134.197L75.3639 132.865L94.1375 139.32Z",
    fill: "#E89E91"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7326 173.205C61.3181 178.816 63.8148 184.001 66.1759 188.15C69.5383 194.02 72.6648 197.821 72.6648 197.821L68.7627 202.634C66.1759 205.828 66.7165 210.528 69.9545 213.059L96.2349 213.182L102.037 213.204C105.343 211.709 106.917 207.919 105.647 204.523L102.914 197.169L102.835 186.216C103.195 186.036 103.533 185.845 103.859 185.62C109.571 181.909 110.235 173.553 104.837 169.044L90.1278 157.45H87.8336H71.6784C63.5278 157.45 57.496 165.202 59.6899 173.052C59.7038 173.103 59.7178 173.154 59.7326 173.205Z",
    fill: "#B0A2F3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M79.255 175.667C80.5591 180.041 82.4595 185.631 84.9116 191.411C87.5653 197.63 91.3661 205.906 96.2359 213.182L102.038 213.204C105.344 211.709 106.918 207.919 105.648 204.523L102.915 197.169L102.836 186.216C103.196 186.036 103.534 185.845 103.86 185.62L101.532 181.515L96.6158 173.836C95.4576 171.081 92.4955 168.646 89.774 167.972C88.2108 167.589 87.0637 169.246 85.4104 169.752C80.6194 171.236 77.8264 170.843 79.255 175.667Z",
    fill: "#A584F1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1684 175.814C80.4849 179.757 83.6578 184.731 87.4261 189.748C92.4548 196.446 99.9756 205.779 108.395 212.151C114.387 216.687 118.771 216.421 121.876 214.468C126.956 211.272 127.604 204.078 123.478 199.718L101.195 176.173L93.3976 165.7C91.6059 163.304 88.8519 162.011 86.0458 162.011C84.4371 162.011 82.8116 162.439 81.3339 163.322C77.0324 165.91 75.6243 171.478 78.1684 175.814Z",
    fill: "#B0A2F3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0462 121.39L70.7757 128.454L71.5689 131.673L73.6904 140.317C74.8356 144.983 78.316 148.724 82.8877 150.202L89.9951 152.501C96.1561 154.495 102.537 150.253 103.159 143.808C103.615 139.079 103.652 133.558 101.894 127.678C99.8473 120.848 94.422 115.485 87.9359 113.313L87.9099 113.304L86.7711 112.955L86.6485 112.924C86.0801 112.77 85.494 112.644 84.9088 112.544C83.5193 112.286 82.0815 112.17 80.6288 112.202L76.0189 112.302C71.3218 112.405 67.9288 116.828 69.0462 121.39Z",
    fill: "#F2C7BF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M102.32 130.338C102.945 133.708 104.935 134.8 106.406 135.138C107.351 135.354 107.973 136.253 107.847 137.215C107.68 138.482 106.783 139.534 105.557 139.896L101.218 141.18C98.8833 141.443 96.8287 139.638 96.7879 137.289L96.6504 129.324L102.32 130.338Z",
    fill: "#F2C7BF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M101.303 133.573C101.344 135.28 100.747 136.679 99.9687 136.698C99.1904 136.717 98.5253 135.348 98.4835 133.64C98.4417 131.933 99.0399 130.533 99.8182 130.515C100.598 130.496 101.262 131.865 101.303 133.573Z",
    fill: "#212121"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M98.878 125.642C95.9466 127.19 95.0271 125.332 97.0928 123.809C99.3146 122.171 102.526 123.717 98.878 125.642Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4688 142.434C94.4688 142.434 100.008 141.946 100.759 143.064C101.509 144.183 96.0756 148 94.4688 142.434Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M89.303 138.747C95.6887 134.433 98.8793 125.643 95.9776 117.528C95.5234 116.267 89.2426 112.298 81.3475 111.632C71.9635 110.839 65.9075 114.311 61.763 118.211C54.6825 124.876 68.8324 140.436 68.8324 140.436L89.303 138.747Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0333 123.119C53.4758 133.098 44.7643 115.041 51.856 109.373C58.9476 103.703 74.748 114.732 65.0333 123.119Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1913 143.855C88.2465 151.936 98.6996 151.286 96.6497 162.341C87.8025 159.01 81.518 163.717 81.0155 171.986C80.5084 180.342 84.3909 184.626 81.4595 190.559L55.4447 185.982C50.4912 175.508 62.214 164.979 59.1256 154.806C54.1211 138.321 57.1584 132.524 60.1399 125.834L86.5114 136.699L87.1913 143.855Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4475 136.894C86.5674 129.324 81.2545 134.719 82.8958 141.6C84.5379 148.48 90.4286 145.38 90.4286 145.38L91.4475 136.894Z",
    fill: "#F2C7BF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3638 142.83L87.1309 139.083",
    stroke: "#E2A8A1",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4697 252.765L51.931 305.742L27.8584 362.196L50.4551 365.305L75.5643 310.316L88.2485 249.107L52.4697 252.765Z",
    fill: "#BBB1B2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9028 253.479L68.1077 306.699L43.083 363.47",
    stroke: "#CBC3C4",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M102.454 222.38L111.684 301.543L111.235 365.432H88.5672L86.0054 307.182L65.0342 249.107L102.454 222.38Z",
    fill: "#CBC3C4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4668 252.765L105.257 264.511L102.453 222.38L102.329 220.57L102.037 213.204L73.9238 213.07L69.954 213.058C69.954 213.058 66.1755 217.5 62.1388 223.932C58.9111 229.116 55.5041 235.583 53.795 242.037C53.2767 244.005 52.8374 247.852 52.4668 252.765Z",
    fill: "#CBC3C4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1455 223.938L102.454 222.382L102.332 220.573L102.034 213.203L73.9204 213.072L69.9514 213.055C69.9514 213.055 66.1757 217.504 62.1455 223.938Z",
    fill: "#BBB1B2"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9685 227.334L70.7464 226.12L66.8369 240.938L73.6128 246.763L84.9734 242.477L86.9685 227.334Z",
    stroke: "#E2DDDE",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9121 213.054L96.6503 259.041L103.488 300.756L102.326 365.432",
    stroke: "#E2DDDE",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4084 213.76C62.7342 228.028 56.4293 240.172 58.0139 254",
    stroke: "#E2DDDE",
    strokeWidth: 0.928835,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M89.365 393.648C88.791 383.386 91.2236 378.169 91.2236 378.169C96.6573 378.169 100.638 381.693 103.319 385.378H116.826C117.179 382.919 117.107 380.529 115.96 379.198C115.96 379.198 134.897 385.072 136.985 393.648V396.097H89.2777V393.648H89.365Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2221 393.648H17.21C17.21 384.287 21.8263 378.169 21.8263 378.169C27.26 378.169 30.6131 381.693 32.6371 385.378H44.9135C45.7048 382.919 46.0587 380.529 45.1494 379.198C45.1494 379.198 65.7343 385.072 66.2925 393.648L66.2628 396.097H17.1924L17.2221 393.648Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M113.463 15.5744L108.052 12.3402L105.72 16.2431C104.62 15.9245 103.498 15.762 102.379 15.7536L101.268 11.3426L95.1541 12.8817L96.265 17.2927C95.2841 17.8305 94.372 18.5048 93.5547 19.3064L89.6517 16.9732L86.4175 22.3846L90.3205 24.7169C90.0019 25.8166 89.8393 26.9387 89.831 28.0579L85.4199 29.1688L86.9599 35.2824L91.371 34.1715C91.9088 35.1524 92.5831 36.0645 93.3847 36.8818L91.0524 40.7848L96.4638 44.019L98.7961 40.117C99.8958 40.4356 101.019 40.5981 102.137 40.6065L103.248 45.0166L109.362 43.4766L108.251 39.0665C109.232 38.5287 110.144 37.8543 110.961 37.0528L114.864 39.3851L118.098 33.9737L114.195 31.6414C114.514 30.5416 114.676 29.4196 114.686 28.3003L119.096 27.1895L117.556 21.0759L113.146 22.1867C112.608 21.205 111.934 20.2938 111.132 19.4764L113.463 15.5744ZM104.773 23.9701C107.094 25.3578 107.854 28.3746 106.466 30.6967C105.079 33.0188 102.062 33.7777 99.7407 32.3909C97.4195 31.0032 96.6588 27.9864 98.0465 25.6643C99.4342 23.3422 102.452 22.5824 104.773 23.9701Z",
    fill: "#E2DDDE"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M357.103 287.948L352.446 287.322L351.993 290.68C351.146 290.785 350.33 291.003 349.561 291.326L347.505 288.629L343.768 291.479L345.824 294.174C345.309 294.831 344.883 295.56 344.558 296.35L341.199 295.897L340.571 300.555L343.93 301.007C344.035 301.854 344.253 302.671 344.575 303.44L341.88 305.495L344.73 309.232L347.425 307.176C348.082 307.691 348.811 308.117 349.6 308.442L349.148 311.801L353.805 312.428L354.258 309.069C355.105 308.965 355.921 308.746 356.69 308.424L358.746 311.119L362.483 308.27L360.427 305.574C360.942 304.917 361.368 304.188 361.693 303.399L365.052 303.851L365.68 299.194L362.321 298.742C362.217 297.894 361.998 297.078 361.676 296.309L364.372 294.253L361.523 290.517L358.828 292.572C358.171 292.058 357.442 291.631 356.652 291.306L357.103 287.948ZM353.759 295.173C356.351 295.522 358.176 297.916 357.827 300.508C357.478 303.101 355.084 304.926 352.492 304.577C349.9 304.227 348.074 301.834 348.424 299.241C348.773 296.648 351.167 294.824 353.759 295.173Z",
    fill: "#E2DDDE"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M297.377 20.0253H235.301C232.658 20.0253 230.508 17.8751 230.508 15.2325C230.508 12.59 232.658 10.4398 235.301 10.4398H297.377C300.02 10.4398 302.17 12.5891 302.17 15.2325C302.17 17.8751 300.021 20.0253 297.377 20.0253ZM235.301 12.2575C233.66 12.2575 232.326 13.5922 232.326 15.2325C232.326 16.8738 233.66 18.2085 235.301 18.2085H297.377C299.018 18.2085 300.353 16.8738 300.353 15.2325C300.353 13.5922 299.018 12.2575 297.377 12.2575H235.301Z",
    fill: "#E2DDDE"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M297.377 32.9724H235.301C232.658 32.9724 230.508 30.8222 230.508 28.1796C230.508 25.5371 232.658 23.3868 235.301 23.3868H297.377C300.02 23.3868 302.17 25.5371 302.17 28.1796C302.17 30.8222 300.021 32.9724 297.377 32.9724ZM235.301 25.2046C233.66 25.2046 232.326 26.5393 232.326 28.1796C232.326 29.82 233.66 31.1547 235.301 31.1547H297.377C299.018 31.1547 300.353 29.82 300.353 28.1796C300.353 26.5393 299.018 25.2046 297.377 25.2046H235.301Z",
    fill: "#E2DDDE"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M297.377 45.9194H235.301C232.658 45.9194 230.508 43.7691 230.508 41.1266C230.508 38.4841 232.658 36.3338 235.301 36.3338H297.377C300.02 36.3338 302.17 38.4841 302.17 41.1266C302.17 43.7691 300.021 45.9194 297.377 45.9194ZM235.301 38.1515C233.66 38.1515 232.326 39.4863 232.326 41.1266C232.326 42.7678 233.66 44.1017 235.301 44.1017H297.377C299.018 44.1017 300.353 42.7669 300.353 41.1266C300.353 39.4853 299.018 38.1515 297.377 38.1515H235.301Z",
    fill: "#E2DDDE"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M242.774 19.117C240.683 19.117 238.988 17.4219 238.988 15.3311V15.1341C238.988 13.0433 240.683 11.3482 242.774 11.3482C244.865 11.3482 246.56 13.0433 246.56 15.1341V15.3311C246.56 17.4219 244.865 19.117 242.774 19.117Z",
    fill: "#E2DDDE"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M276.55 32.064C274.459 32.064 272.764 30.3688 272.764 28.278V28.0811C272.764 25.9903 274.459 24.2952 276.55 24.2952C278.64 24.2952 280.336 25.9903 280.336 28.0811V28.278C280.335 30.3688 278.64 32.064 276.55 32.064Z",
    fill: "#E2DDDE"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M253.421 45.0111C251.33 45.0111 249.635 43.316 249.635 41.2252V41.0282C249.635 38.9374 251.33 37.2423 253.421 37.2423C255.511 37.2423 257.207 38.9374 257.207 41.0282V41.2252C257.207 43.316 255.511 45.0111 253.421 45.0111Z",
    fill: "#E2DDDE"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M171.206 4.60311C171.202 6.20814 169.897 7.5048 168.292 7.50015C166.687 7.49551 165.39 6.19049 165.395 4.58547C165.399 2.98044 166.704 1.68378 168.309 1.68843C169.914 1.69307 171.211 2.99809 171.206 4.60311Z",
    stroke: "#E7DDDD",
    strokeWidth: 2.78651,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2483 307.11C33.2436 308.716 31.9386 310.013 30.3336 310.008C28.7285 310.003 27.4319 308.698 27.4365 307.093C27.4412 305.488 28.7462 304.191 30.3512 304.196C31.9562 304.2 33.2529 305.505 33.2483 307.11Z",
    stroke: "#E7DDDD",
    strokeWidth: 2.78651,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01095 124.227C8.00631 125.832 6.7013 127.129 5.09627 127.124C3.49124 127.12 2.19459 125.815 2.19923 124.21C2.20388 122.605 3.50889 121.308 5.11392 121.313C6.71894 121.317 8.0156 122.622 8.01095 124.227Z",
    stroke: "#E7DDDD",
    strokeWidth: 2.78651,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M337.546 33.5048C337.541 35.1098 336.236 36.4065 334.631 36.4018C333.026 36.3972 331.73 35.0922 331.734 33.4871C331.739 31.8821 333.044 30.5855 334.649 30.5901C336.254 30.5957 337.551 31.9007 337.546 33.5048Z",
    stroke: "#E7DDDD",
    strokeWidth: 2.78651,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M391.946 285.213C391.942 286.818 390.637 288.115 389.032 288.11C387.427 288.106 386.13 286.801 386.135 285.196C386.139 283.591 387.444 282.294 389.049 282.298C390.654 282.303 391.951 283.608 391.946 285.213Z",
    stroke: "#E7DDDD",
    strokeWidth: 2.78651,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9231_28168",
    x1: 298.891,
    y1: 204.314,
    x2: 212.656,
    y2: 124.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9231_28168",
    x1: 277.625,
    y1: 227.304,
    x2: 191.39,
    y2: 147.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9231_28168",
    x1: 195.103,
    y1: 64.9301,
    x2: 260.634,
    y2: 120.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsectionicon);
export default __webpack_public_path__ + "static/media/chatsectionicon.36b45ff2a4321d241f8133934c713fd4.svg";
export { ForwardRef as ReactComponent };